import { createRouter, createWebHistory } from 'vue-router'
import NotFound from '@/views/NotFound.vue'


const routes = [
  {
    path: '/',
    name: 'home',
    redirect: { name: 'projects' },
  },
  {
    path: '/beta',
    name: 'beta',
    component: () => import(/* webpackChunkName: "guest" */ '@/views/BetaView'),
  },
  {
    path: '/editor/:project_id?',
    name: 'editor',
    component: () =>
      import(/* webpackChunkName: "user" */ '@/views/EditorView'),
    meta: {
      authorized: true,
      lastMile: true,
    },
  },
  {
    path: '/projects',
    name: 'projects',
    component: () =>
      import(/* webpackChunkName: "user" */ '@/views/ProjectsView'),
    meta: {
      authorized: true,
      lastMile: true,
    },
  },
  {
    path: '/dataroom',
    name: 'dataroom',
    component: () =>
      import(/* webpackChunkName: "dataroom" */ '@/views/dataroom/DataRoomLayout'),
    children: [
      {
        path: '',
        redirect: { name: 'dataroom:overview' },
      },
      {
        path: 'overview',
        name: 'dataroom:overview',
        component: () =>
          import(/* webpackChunkName: "dataroom" */ '@/views/dataroom/DataRoomOverview'),
      },
      {
        path: 'deck',
        name: 'dataroom:deck',
        component: () =>
          import(/* webpackChunkName: "dataroom" */ '@/views/dataroom/DataRoomDeck'),
      },
      {
        path: 'product',
        name: 'dataroom:product',
        component: () =>
          import(/* webpackChunkName: "dataroom" */ '@/views/dataroom/DataRoomProduct'),
      },
      {
        path: 'market',
        name: 'dataroom:market',
        component: () =>
          import(/* webpackChunkName: "dataroom" */ '@/views/dataroom/DataRoomMarket'),
      },
      {
        path: 'financial-model',
        name: 'dataroom:financial-model',
        component: () =>
          import(/* webpackChunkName: "dataroom" */ '@/views/dataroom/DataRoomFinancialModel'),
        meta: {
          dataroomAccess: 'full',
        },
      },
      {
        path: 'traction',
        name: 'dataroom:traction',
        component: () =>
          import(/* webpackChunkName: "dataroom" */ '@/views/dataroom/DataRoomTraction'),
        meta: {
          dataroomAccess: 'full',
        },
      },
      {
        path: 'roadmap',
        name: 'dataroom:roadmap',
        component: () =>
          import(/* webpackChunkName: "dataroom" */ '@/views/dataroom/DataRoomRoadmap'),
        meta: {
          dataroomAccess: 'full',
        },
      },
      {
        path: 'team',
        name: 'dataroom:team',
        component: () =>
          import(/* webpackChunkName: "dataroom" */ '@/views/dataroom/DataRoomTeam'),
        meta: {
          dataroomAccess: 'full',
        },
      },
      {
        path: 'files',
        name: 'dataroom:files',
        component: () =>
          import(/* webpackChunkName: "dataroom" */ '@/views/dataroom/DataRoomFiles'),
        meta: {
          dataroomAccess: 'full',
        },
      },
      {
        path: 'faq',
        name: 'dataroom:faq',
        component: () =>
          import(/* webpackChunkName: "dataroom" */ '@/views/dataroom/DataRoomFAQ'),
      },
      {
        path: 'admin',
        name: 'dataroom:admin',
        component: () =>
          import(/* webpackChunkName: "dataroom" */ '@/views/dataroom/DataRoomAdmin'),
        meta: {
          dataroomAccess: 'owner',
        },
      },
    ],
  },
  {
    path: '/backstage',
    name: 'backstage',
    component: () =>
      import(/* webpackChunkName: "admin" */ '@/views/BackstageView'),
    meta: {
      authorized: true,
      admin: true,
    },
    children: [
      {
        path: '',
        name: 'backstage:settings',
        component: () =>
          import(/* webpackChunkName: "admin" */ '@/views/BackstageSettings'),
      },
      {
        path: 'flows',
        name: 'backstage:workflows',
        component: () =>
          import(/* webpackChunkName: "admin" */ '@/views/WorkflowsView'),
      },
      {
        path: 'flow/:uuid?',
        name: 'backstage:workflow',
        component: () =>
          import(/* webpackChunkName: "admin" */ '@/views/WorkflowFormView'),
      },
      {
        path: 'presets',
        name: 'backstage:presets',
        component: () =>
          import(/* webpackChunkName: "admin" */ '@/views/PresetsView'),
      },
      {
        path: 'node-workflows',
        name: 'backstage:node-workflows',
        component: () =>
          import(/* webpackChunkName: "admin" */ '@/views/NodeWorkflowsView'),
      },
      {
        path: 'personalities',
        name: 'backstage:personalities',
        component: () =>
          import(/* webpackChunkName: "admin" */ '@/views/PersonalitiesView'),
      },
      {
        path: 'tpls',
        name: 'backstage:templates',
        component: () =>
          import(/* webpackChunkName: "user" */ '@/views/TemplatesView'),
      },
      {
        path: 'tpl/:tpl?',
        name: 'backstage:template',
        component: () =>
          import(/* webpackChunkName: "user" */ '@/views/TplEditView'),
      },
    ],
  },
  {
    path: '/by/:username',
    name: 'by',
    component: () =>
      import(/* webpackChunkName: "user" */ '@/views/ProfileView'),
    meta: {
      authorized: true,
    },
  },
  {
    path: '/me',
    name: 'profile',
    component: () =>
      import(/* webpackChunkName: "user" */ '@/views/ProfileView'),
    meta: {
      authorized: true,
    },
  },
  {
    path: '/league',
    name: 'league',
    component: () =>
      import(/* webpackChunkName: "user" */ '@/views/LeagueView'),
    meta: {
      authorized: true,
    },
  },
  {
    path: '/league/commons',
    name: 'league-commons',
    component: () =>
      import(/* webpackChunkName: "user" */ '@/views/LeagueCommonsView'),
    meta: {
      authorized: true,
    },
  },
  {
    path: '/league/members/:handle',
    name: 'league-member-profile',
    component: () =>
      import(/* webpackChunkName: "user" */ '@/views/LeagueMemberProfileView'),
    meta: {
      authorized: true,
    },
  },
  {
    path: '/league/bounty-house',
    name: 'bounty-house',
    component: () =>
      import(/* webpackChunkName: "user" */ '@/views/BountyHouseView'),
    meta: {
      authorized: true,
    },
  },
  {
    path: '/league/museum-tower',
    name: 'museum-tower',
    component: () =>
      import(/* webpackChunkName: "user" */ '@/views/MuseumTowerView'),
    meta: {
      authorized: true,
    },
  },
  {
    path: '/sign-up/:invite',
    name: 'sign-up',
    component: () => import(/* webpackChunkName: "guest" */ '@/views/SignUp'),
  },
  {
    path: '/sign-in',
    name: 'sign-in',
    component: () => import(/* webpackChunkName: "guest" */ '@/views/SignIn'),
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () =>
      import(/* webpackChunkName: "guest" */ '@/views/ResetPassword'),
  },
  {
    path: '/not-authorized',
    name: 'not-authorized',
    component: () =>
      import(/* webpackChunkName: "guest" */ '@/views/NotAuthorized'),
  },
  {
    path: '/logout',
    name: 'logout',
    component: () =>
      import(/* webpackChunkName: "guest" */ '@/views/LogoutView'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: NotFound,
    meta: {
      lastMile: true,
    },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

export default router
